import { createAction, handleActions } from 'redux-actions'

const setFilters = createAction('SCREENS/SUBBIES/SUB_PROJECTS/SET_FILTERS')
const setFilter = createAction('SCREENS/SUBBIES/SUB_PROJECTS/SET_FILTER')
const resetFilters = createAction('SCREENS/SUBBIES/SUB_PROJECTS/RESET_FILTERS')

const defaultState = {
  statusKey: 2,
  subcontractorIds: [],
  projectIds: [],
  contractsManagerIds: [],
  completionStatuses: [],
  hideComplete: false,
}

const reducer = handleActions(
  {
    [setFilters]: (state, { payload }) => payload,
    [setFilter]: (state, { payload }) => ({ ...state, [payload.field]: payload.value }),
    [resetFilters]: () => defaultState,
  },
  defaultState,
)

export { setFilters, setFilter, resetFilters, reducer }
